<template>
<div class="chapter">
<div class="inner_page">
<a id="page_8"></a>
<h2 class="fm_title1" id="time">TIMELINE</h2>
<table class="table">
<tbody><tr>
<td class="td1"><span class="bold">30 Jan 1933</span></td>
<td class="td2">Hitler becomes Reichskanzler of Germany</td>
</tr>
<tr>
<td class="td1"><span class="bold">12 Mar 1938</span></td>
<td class="td2"><em class="italic">Anschluß</em> – Hitler annexes Austria</td>
</tr>
<tr>
<td class="td1"><span class="bold">Mar 1938</span></td>
<td class="td2">Foreign Office set up Elektra House (EH) propaganda unit</td>
</tr>
<tr>
<td class="td1"><span class="bold">Apr 1938</span></td>
<td class="td2">SIS (<a href="#/xhtml/06_Glossary#rgloss_69" id="gloss_69">MI6</a>) creates Section D</td>
</tr>
<tr>
<td class="td1"><em class="italic"><span class="bold">c</span></em><span class="bold">. Oct 1938</span></td>
<td class="td2">GS(R) – later renamed MI(R) – created in War Office</td>
</tr>
<tr>
<td class="td1"><span class="bold">1 Sep 1939</span></td>
<td class="td2">Germany invades Poland</td>
</tr>
<tr>
<td class="td1"><span class="bold">1 Sep 1939</span></td>
<td class="td2">Section D moves to Frythe, near Welwyn, Hertfordshire</td>
</tr>
<tr>
<td class="td1"><span class="bold">Apr–Jun 1940</span></td>
<td class="td2">Independent Companies under Colin Gubbins operate in Norway</td>
</tr>
<tr>
<td class="td1"><span class="bold">10 May 1940</span></td>
<td class="td2">Winston Churchill becomes Prime Minister</td>
</tr>
<tr>
<td class="td1"><span class="bold">May 1940</span></td>
<td class="td2">British Security Coordination office established in New York</td>
</tr>
<tr>
<td class="td1"><span class="bold">22 Jun 1940</span></td>
<td class="td2">France surrenders</td>
</tr>
<tr>
<td class="td1"><span class="bold">Jun–Jul 1940</span></td>
<td class="td2">‘Wild Bill’ Donovan’s first survey trip to Britain</td>
</tr>
<tr>
<td class="td1"><span class="bold">Jul 1940</span></td>
<td class="td2">First meeting between ‘Intrepid’ and ‘Wild Bill’</td>
</tr>
<tr>
<td class="td1"><span class="bold">Jul 1940</span></td>
<td class="td2">General Headquarters Auxiliary Units created for UK Home Defence</td>
</tr>
<tr>
<td class="td1"><span class="bold">22 Jul 1940</span></td>
<td class="td2">SOE Charter approved, formed from Section D, MI(R) and EH</td>
</tr>
<tr>
<td class="td1"><span class="bold">28 Aug 1940</span></td>
<td class="td2">Sir Frank Nelson appointed ‘CD’ – head of SOE</td>
</tr>
<tr>
<td class="td1"><span class="bold">Oct 1940</span></td>
<td class="td2">Italy invades Crete, Germany follows in April 1941</td>
</tr>
<tr>
<td class="td1"><span class="bold">Nov 1940</span></td>
<td class="td2">Gubbins returns to SOE as Director of Training and Operations</td>
</tr>
<tr>
<td class="td1"><span class="bold">Dec 1940</span></td>
<td class="td2">Donovan begins second trip to Britain, Mediterranean and Balkans; returns February 1941</td>
</tr>
<tr>
<td class="td1"><span class="bold">5 May 1941</span></td>
<td class="td2">First successful SOE infiltration into France; George Bégué sets up circuit and meets follow-on agents</td>
</tr>
<tr>
<td class="td1"><a id="page_9"></a><span class="bold">20 May 1941</span></td>
<td class="td2">Germany invades Crete</td>
</tr>
<tr>
<td class="td1"><span class="bold">11 Jul 1941</span></td>
<td class="td2">Creation of COI</td>
</tr>
<tr>
<td class="td1"><span class="bold">6 Dec 1941</span></td>
<td class="td2">Camp X (STS 103) opens in Canada</td>
</tr>
<tr>
<td class="td1"><span class="bold">7 Dec 1941</span></td>
<td class="td2">Japan attacks Pearl Harbor</td>
</tr>
<tr>
<td class="td1"><span class="bold">15 Feb 1942</span></td>
<td class="td2">Singapore falls to the Japanese</td>
</tr>
<tr>
<td class="td1"><span class="bold">Mar 1942</span></td>
<td class="td2">Charles Jocelyn Hambro replaces Nelson as CD</td>
</tr>
<tr>
<td class="td1"><span class="bold">13 Jun 1942</span></td>
<td class="td2">OSS replaces COI, placed under JCS</td>
</tr>
<tr>
<td class="td1"><span class="bold">23 Oct 1942</span></td>
<td class="td2">Second battle of El Alamein</td>
</tr>
<tr>
<td class="td1"><span class="bold">8 Nov 1942</span></td>
<td class="td2">Operation <em class="italic">Torch</em> – the Allied invasion of North Africa – begins</td>
</tr>
<tr>
<td class="td1"><span class="bold">Dec 1942</span></td>
<td class="td2">First successful OSS infiltration into Europe (Corsica)</td>
</tr>
<tr>
<td class="td1"><span class="bold">3 Sep 1943</span></td>
<td class="td2">Allies invade Italy, Italy surrenders</td>
</tr>
<tr>
<td class="td1"><span class="bold">Sep 1943</span></td>
<td class="td2">Gubbins becomes director of SOE</td>
</tr>
<tr>
<td class="td1"><span class="bold">5/6 Jun 1944</span></td>
<td class="td2">1st JEDBURGH teams dropped into France</td>
</tr>
<tr>
<td class="td1"><span class="bold">6 Jun 1944</span></td>
<td class="td2">Operation <em class="italic">Overlord</em>, the invasion of Normandy</td>
</tr>
<tr>
<td class="td1"><span class="bold">15 Aug 1944</span></td>
<td class="td2">Operation <em class="italic">Dragoon</em>, the invasion of southern France</td>
</tr>
<tr>
<td class="td1"><span class="bold">17 Sep 1944</span></td>
<td class="td2">Operation <em class="italic">Market Garden</em> begins</td>
</tr>
<tr>
<td class="td1"><span class="bold">7 May 1945</span></td>
<td class="td2">Germany surrenders</td>
</tr>
<tr>
<td class="td1"><span class="bold">2 Sep 1945</span></td>
<td class="td2">Japan surrenders</td>
</tr>
<tr>
<td class="td1"><span class="bold">20 Sep 1945</span></td>
<td class="td2">Executive Order 9621 abolishes the OSS</td>
</tr>
<tr>
<td class="td1"><span class="bold">15 Jan 1946</span></td>
<td class="td2">SOE dissolved by Prime Minister Clement Attlee</td>
</tr>
<tr>
<td class="td1"><span class="bold">22 Jan 1946</span></td>
<td class="td2">President Truman directs establishment of Central Intelligence Group, forerunner of the CIA</td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Timeline.vue?689a6eda